import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initPixel } from './lib/pixel';
import { captureAfParam } from './lib/afMode';
import { initStoryFont } from './lib/storyFonts';

initPixel();
// Publish the admin-chosen story font as --story-font before the book renders.
initStoryFont();
// Consume one-shot deep-link params (?af=pdf) before the router mounts: the
// flag is stashed for the tab session and stripped from the address bar.
captureAfParam();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
